/* ToveGolf PDP behaviours: one shipping calculation shared by the buy-box bar and the sticky bar,
   sticky add-to-cart mirroring Dawn's real submit button, and the mix-and-match bundle.
   Merchant text placeholders use square brackets: [amount] [threshold] [pct]. */
(function(){
'use strict';
var $=function(s,c){return (c||document).querySelector(s)};
var $$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};
var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var FREE=(window.tgSettings&&window.tgSettings.freeShippingThreshold)||7500;

function money(cents){
  var fmt=(window.tgSettings&&window.tgSettings.moneyFormat)||'${{amount}}';
  var v=(cents/100).toFixed(2);
  return fmt.replace(/\{\{\s*amount\s*\}\}/,v).replace(/\{\{\s*amount_no_decimals\s*\}\}/,Math.round(cents/100)).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/,v.replace('.',','));
}
function fill(tpl,map){return (tpl||'').replace(/\[(amount|threshold|pct)\]/g,function(_,k){return map[k]!==undefined?map[k]:''});}

/* ---------- shipping progress (single source of truth) ---------- */
function paintShipping(sub){
  var remaining=Math.max(FREE-sub,0),pct=Math.min(sub/FREE*100,100),unlocked=sub>=FREE;
  $$('[data-tg-ship]').forEach(function(box){
    var f=box.querySelector('.tg-ship__fill'),msg=box.querySelector('[data-tg-ship-msg]');
    if(f)f.style.width=pct+'%';
    if(msg){
      var tpl=unlocked?box.dataset.after:(sub>0?box.dataset.before:(box.dataset.empty||box.dataset.before));
      msg.innerHTML=fill(tpl,{amount:'<b>'+money(remaining)+'</b>',threshold:'<b>'+money(FREE)+'</b>'});
    }
    var num=box.querySelector('[data-tg-ship-num]'); if(num)num.textContent=money(sub)+' · free at '+money(FREE);
  });
}
function refreshCart(){
  fetch(window.routes&&window.routes.cart_url?window.routes.cart_url+'.js':'/cart.js',{headers:{'Accept':'application/json'}})
    .then(function(r){return r.json()}).then(function(c){paintShipping(c.items_subtotal_price||c.total_price||0)}).catch(function(){});
}
if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'&&PUB_SUB_EVENTS.cartUpdate){
  subscribe(PUB_SUB_EVENTS.cartUpdate,function(){setTimeout(refreshCart,150)});
}

/* ---------- sticky bar ---------- */
function sticky(){
  var bar=$('[data-tg-sticky]'); if(!bar||bar.dataset.wired)return; bar.dataset.wired=1;
  var sid=bar.dataset.section,submit=$('#ProductSubmitButton-'+sid),price=$('#price-'+sid),cta=bar.querySelector('.tg-sticky__cta'),sp=bar.querySelector('.tg-sticky__price');
  if(!submit)return;
  function mirror(){
    if(sp&&price){var p=price.querySelector('.price__container');sp.innerHTML=p?p.innerHTML:price.innerText;}
    var dis=submit.disabled||submit.getAttribute('aria-disabled')==='true';
    cta.disabled=dis; cta.textContent=dis?(submit.querySelector('span')?submit.querySelector('span').textContent.trim():cta.dataset.soldout):cta.dataset.label;
  }
  new MutationObserver(mirror).observe(submit,{attributes:true,childList:true,subtree:true});
  if(price)new MutationObserver(mirror).observe(price,{childList:true,subtree:true,characterData:true});
  mirror();
  cta.addEventListener('click',function(){ if(!cta.disabled)submit.click(); });
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(es){var on=!es[0].isIntersecting&&es[0].boundingClientRect.top<0;bar.classList.toggle('is-on',on);bar.setAttribute('aria-hidden',!on);document.body.classList.toggle('tg-sticky-on',on);},{threshold:0}).observe(submit);
  }
  var mo=new MutationObserver(function(){var open=document.querySelector('cart-drawer.active, cart-drawer.animate, modal-dialog[open], details[open].menu-drawer-container');document.body.classList.toggle('tg-no-sticky',!!open);});
  mo.observe(document.body,{attributes:true,subtree:true,attributeFilter:['class','open']});
}

/* ---------- mix & match bundle ---------- */
function bundles(){
  $$('[data-tg-bundle]').forEach(function(box){
    if(box.dataset.wired)return; box.dataset.wired=1;
    var sid=box.dataset.section,base=+box.dataset.base,t2=+box.dataset.t2,t3=+box.dataset.t3;
    var items=$$('.tg-bnd__item[data-price]',box),tiers=$$('.tg-bnd__tier',box),tot=box.querySelector('[data-tot]'),was=box.querySelector('[data-was]'),save=box.querySelector('[data-save]'),lead=box.querySelector('[data-lead]'),add=box.querySelector('.tg-bnd__add');
    function picked(){return items.filter(function(i){return i.classList.contains('is-on')})}
    function disc(n){return n>=3?t3:n===2?t2:0}
    function paint(){
      var ps=picked(),n=1+ps.length,d=disc(n);
      var sub=base+ps.reduce(function(s,i){var sel=i.querySelector('select');var opt=sel&&sel.selectedOptions[0];return s+(opt?+opt.dataset.price:+i.dataset.price)},0);
      var total=Math.round(sub*(1-d/100));
      tiers.forEach(function(t){var v=+t.dataset.tier;t.classList.toggle('is-on',n>=v);t.classList.toggle('is-next',v===n+1)});
      tot.textContent=money(total); was.hidden=!d; was.textContent=money(sub); save.hidden=!d; save.textContent=fill(box.dataset.savelabel,{amount:money(sub-total),pct:d});
      lead.textContent=n===1?fill(box.dataset.lead1,{pct:t2}):(n===2?fill(box.dataset.lead2,{pct:t3}):fill(box.dataset.lead3,{pct:t3}));
      add.disabled=ps.length===0;
    }
    items.forEach(function(i){
      var tg=i.querySelector('.tg-bnd__toggle');
      if(tg)tg.addEventListener('click',function(){i.classList.toggle('is-on');paint();});
      var sel=i.querySelector('select'); if(sel)sel.addEventListener('change',paint);
    });
    add.addEventListener('click',function(){
      var main=$('#product-form-'+sid+' input[name="id"]')||$('form[id^="product-form-'+sid+'"] input[name="id"]');
      var list=[]; if(main)list.push({id:+main.value,quantity:1});
      picked().forEach(function(i){var sel=i.querySelector('select');var id=sel?+sel.value:+i.dataset.variant;if(id)list.push({id:id,quantity:1});});
      if(!list.length)return;
      add.disabled=true;var lbl=add.textContent;add.textContent=add.dataset.adding||'Adding…';
      var body={items:list};
      var drawer=document.querySelector('cart-drawer');
      if(drawer){body.sections='cart-drawer,cart-icon-bubble';body.sections_url=window.location.pathname;}
      fetch((window.routes&&window.routes.cart_add_url)||'/cart/add',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
        .then(function(r){return r.json()}).then(function(res){
          if(res.status){throw new Error(res.description||'error');}
          /* publish BEFORE re-rendering the drawer, exactly as Dawn's product-form does: Dawn's cart-items handler replaces whichever cart-items element is live at the time */
          if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){publish(PUB_SUB_EVENTS.cartUpdate,{source:'tg-bundle',cartData:res});}
          if(drawer&&typeof drawer.renderContents==='function'){drawer.classList.remove('is-empty');drawer.renderContents(res);}
          refreshCart();
        }).catch(function(){alert((box.dataset.error||'Something went wrong adding the bundle.'));})
        .finally(function(){add.disabled=false;add.textContent=lbl;});
    });
    paint();
  });
}

function init(){sticky();bundles();refreshCart();}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();
